import { com } from '@eidu/form'
import DraftFieldValue from '../../../../domain/entity/DraftFieldValue'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import FieldId = com.eidu.sharedlib.entity.field.FieldId

const computeLabel = (entityType: EntityType, fields: ReadonlyMap<FieldId, DraftFieldValue>): string | undefined => {
  const labelLine = entityType.label.primary
  const argFields = labelLine.argumentFields.asJsReadonlyArrayView()

  const values = argFields.map((fieldId) => fields.get(fieldId)?.value ?? '')
  if (values.every((v) => v === '')) return undefined

  return labelLine.format.format(values)
}

export default computeLabel
